<dcr-top-app-bar class="p-b-2xs">
  <a (click)="navigateTo('/')" slot="tiny-logo" class="dk-logo"><dcr-logo logo="diekeure:square:full"></dcr-logo></a>

  @if (mobile$ | async) {
    <div class="relative" slot="actions">
      <dcr-inline-icon-button id="btn-menu" icon="navigation:menu"></dcr-inline-icon-button>
      <dcr-menu anchor="btn-menu" [attr.has-overflow]="!!(headerActions$ | async)">
        @for (link of headerLinks; track link) {
          <dcr-menu-item type="link" [attr.href]="link.route.url" [leadingIcon]="link.icon" [label]="link.label"></dcr-menu-item>
        }
        <dcr-divider></dcr-divider>
        @if (headerActions$ | async; as headerActions) {
          <dcr-sub-menu preferred-direction="start">
            <dcr-menu-item slot="item" label="Aanmelden"></dcr-menu-item>
            <dcr-menu slot="menu">
              @for (child of headerActions.children; track child) {
                <dcr-menu-item
                  [type]="child.href ? 'link' : 'button'"
                  [label]="child.label"
                  [leadingIcon]="child.icon"
                  [attr.href]="child.href ? child.href : undefined"
                  (click)="child.action && child.action()"
                ></dcr-menu-item>
              }
            </dcr-menu>
          </dcr-sub-menu>
        }
      </dcr-menu>
    </div>
  } @else {
    <div class="navigation-bar" slot="actions">
      @for (link of headerLinks; track link) {
        <a class="bar-item" [attr.id]="'link' + link.id" [attr.href]="link.route.url" tabindex="0">
          <span class="icon-container">
            <dcr-icon size="l" [attr.icon]="link.icon"></dcr-icon>
            <dcr-state-layer [attr.for]="'link' + link.id"></dcr-state-layer>
            <dcr-focus-ring [attr.for]="'link' + link.id"></dcr-focus-ring>
          </span>
          <span class="label">{{ link.label }}</span>
        </a>
      }
      @if (headerActions$ | async; as headerActions) {
        <div class="login-actions">
          <dcr-filled-button
            id="btn-login"
            [label]="headerActions.label"
            trailing-icon="navigation:arrow_drop_down"
            data-cy="btn-header-dropdown-open"
          ></dcr-filled-button>
          <dcr-menu anchor="btn-login">
            @for (child of headerActions.children; track child) {
              <dcr-menu-item
                [type]="child.href ? 'link' : 'button'"
                [label]="child.label"
                [leadingIcon]="child.icon"
                [attr.href]="child.href ? child.href : undefined"
                (click)="child.action && child.action()"
                data-cy="btn-dropdown-action"
              ></dcr-menu-item>
            }
          </dcr-menu>
        </div>
      }
    </div>
  }
</dcr-top-app-bar>
